export const changingReasons = {
  'Increased Rates': true,
  'Change in coverage needs': true,
  'Not happy with current service': true,
  'A provider or medication is not covered': true,
  Other: true
}
